import { render, staticRenderFns } from "./EximMasterFreightIndex.vue?vue&type=template&id=946e84ea&scoped=true&"
import script from "./EximMasterFreightIndex.vue?vue&type=script&lang=js&"
export * from "./EximMasterFreightIndex.vue?vue&type=script&lang=js&"
import style0 from "./EximMasterFreightIndex.vue?vue&type=style&index=0&id=946e84ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946e84ea",
  null
  
)

export default component.exports